/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum ProductTypeEnum {
  "PP" = "PP",

  "DEB" = "DEB"
}

export enum ValidityStateEnum {
  "V" = "V",

  "BR" = "BR"
}

// required attributes
const CardR = t.interface({});

// optional attributes
const CardO = t.partial({
  abi: t.string,

  cardNumber: t.string,

  cardPartialNumber: t.string,

  expiringDate: UTCISODateFromString,

  hpan: t.string,

  productType: enumType<ProductTypeEnum>(ProductTypeEnum, "productType"),

  tokens: t.readonlyArray(t.string, "array of string"),

  validityState: enumType<ValidityStateEnum>(ValidityStateEnum, "validityState")
});

export const Card = t.intersection([CardR, CardO], "Card");

export type Card = t.TypeOf<typeof Card>;
